module.exports = __webpack_public_path__ + "static/media/BLZD-BUSD.87142171.png";